import api from "Common/Client/Interceptor";

// Get payment ledger list
export const getPaymentLedgerList = async (params = {}) => {
  try {
    const response = await api.get("/indv/LearnerPaymentLedger/Learner/Get-List", {
      params: {
        pageNumber: params.pageNumber || 1,
        pageSize: params.pageSize || 10,
        orderByLatest: params.orderByLatest || true,
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching payment ledger:", error);
    throw error;
  }
};

// Get payment ledger by ID
export const getPaymentLedgerById = async (id) => {
  try {
    const response = await api.get(`/indv/LearnerPaymentLedger/Get-By-Id/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment ledger by ID:", error);
    throw error;
  }
};


export const getSpendingOverview = async () => {
  try {
    const response = await api.get("/indv/LearnerPaymentLedger/Learner/Spending-overview");
    return response.data;
  } catch (error) {
    console.error("Error fetching spending overview:", error);
    throw error;
  }
};